<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <iq-card>
          <loader :isLoading="loadingData" />
          <group-offer-modal 
            ref="groupOfferModal"
            :offers = "offers"
            :group_offers = "group_offers"   
            :group_id="group_id" 
            :isManager="isManager"
            :isAdmin="isAdmin"
            :isPublisher="isPublisher"
            :links="links"
            :group_name="group_name">
          </group-offer-modal>
          <template v-slot:headerTitle>
            <h4 class="card-title">Offer Group</h4>
          </template>
          <template v-slot:headerAction>
            <b-button @click="showModal" variant="primary">Add New</b-button>
            <b-modal ref="myModalRef" id="modal-4" size="lg" title="Add Offer Group" hide-footer>
              <form class="mt-4" @submit.prevent="submitForm">
                <b-form-group >
                  <label for="name">Name</label><span class="text-danger"> *</span>
                  <b-form-input id="name" type="text" placeholder="Enter Name" v-model="items.name"></b-form-input>
                  <span v-if="allerros.name" :class="['label label-danger']">@{{ allerros.name[0] }}</span>
                </b-form-group>
                <b-form-group>
                <label for="status">Status</label><span class="text-danger"> *</span>
                      <b-form-select plain v-model="items.status" :options="group_status" size="lg">
                        <template v-slot:first>
                          <b-form-select-option :value="null">Select Status</b-form-select-option>
                        </template>
              </b-form-select>
              </b-form-group> 
                <b-button type="submit" variant="primary" :disabled="!allFieldsValid">Submit</b-button>
              </form>
            </b-modal>
          </template>
          <template>
            <b-row>

              <b-col md="12" class="table-responsive">
                <b-col sm="0" md="3" class="my-1" style="float: left;">
              <div>Total Rows : {{ totalRows}}</div>
            </b-col>
              <b-col sm="0" md="3" class="my-1" style="float: right;">
      <b-form-group
        label="Page"
        label-for="per-page-select"
        label-cols-sm="2"
        label-cols-md="2"
        label-cols-lg="2"
        label-align-sm="right"
        label-size="sm"
        class="mb-0"
      >
        <b-form-select
          id="per-page-select"
          v-model="perPage"
          :options="pageOptions"
          @change="handleFilterBlur"
          size="sm"
        ></b-form-select>
      </b-form-group>
    </b-col>
              <b-table bordered hover 
              :items="group_rows" 
              :fields="columns"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              stacked="md"
              show-empty
              small
              >
              <template slot="top-row" slot-scope="{ fields }">
                <td v-for="field in fields" :key="field.key" >
                  <template v-if="field.key === 'status'">
                    <b-form-select v-model="filters[field.key]"  @change="handleFilterBlur" :options="group_status" prepend-top>
                      <template #first>
                        <b-form-select-option :value="null">All</b-form-select-option>
                      </template>
                    </b-form-select>
                </template>
                <template v-else>
                  <b-form-input v-model="filters[field.key]" v-if="filters.hasOwnProperty(field.key)" @blur="handleFilterBlur" @keyup.enter="handleFilterBlur"></b-form-input>
                </template>
                </td>
              </template>
                  <template v-slot:cell(name)="data">
                    <span v-if="!data.item.editable">{{ data.item.name }}</span>
                    <input type="text" v-model="data.item.name" v-else class="form-control">
                  </template>
                  <template v-slot:cell(status)="data">
                    <b-button variant=" iq-bg-danger" @click="update(data.item)" v-if="data.item.status_text == 'INACTIVE'" size="sm">{{ data.item.status_text}}</b-button>
                    <b-button variant=" iq-bg-success" @click="update(data.item)" v-else size="sm">{{ data.item.status_text}}</b-button>
                  </template>
                  <template v-slot:cell(action)="data">
                     <b-button variant=" iq-bg-success mr-1 mb-1" size="sm" @click="edit(data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0"></i></b-button>
                  <b-button variant=" iq-bg-success mr-1 mb-1" size="sm" @click="submit(data.item)" v-else>Ok</b-button>
                  <b-button variant=" iq-bg-primary" size="sm" @click="openOffer(data.item)" title="insert offers"><i class="ri-briefcase-2-fill m-0"></i></b-button>
                  <b-button variant=" iq-bg-danger" size="sm" @click="remove(data.item)"><i class="ri-delete-bin-line m-0"></i></b-button>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </template>
          <template>
        <b-col sm="3" md="2" class="my-1" v-if="group_rows.length > 0">
      <b-pagination
        v-model="currentPage" 
        :total-rows="totalRows"
        :per-page="perPage"
        prev-text="Previous"
        next-text="Next"
        first-text="First"
        last-text="Last"
      ></b-pagination>
    </b-col>
  </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
  
</template>
<script>
import { sofbox } from '../../config/pluginInit'
import GroupOfferModal from './GroupOfferModal.vue'
import Offer from '../../Apis/offer'
import Common from '../../Apis/common'
import Loader from '../../components/Loader.vue'
export default {
  name: 'UiDataTable',
  mounted () {
    sofbox.index()
  },
  components: {
    GroupOfferModal,Loader
  },
  methods: {
    default () {
      return {
        items:{
        _id:'',
        name: '',
       status: '',
        },
        editable: false
      }
    },
    handleFilterBlur() {
      this.currentPage = 1; // Reset the current page when filtering
        this.listOfferGroup(); // Call list offe group when filter input is blurred
      },
    showModal(){
      this.items = this.default()
      this.allerros = {}
      this.$refs.myModalRef.show();
    },
    async openOffer(item){
      this.group_id = item._id
      this.group_name = item.name
      this.hosts = process.env.VUE_APP_BASE_URL;
      if (this.isPublisher) {
      this.links = this.hosts+"site/group_click?group_id="+this.group_id+"&user_id="+this.login_id;
      }
      await this.listOfferGroupOffer(item._id)
      await this.listActiveOffer()
      this.$refs.groupOfferModal.show();
    },
    edit(item) {
      if(this.editable_master == true){
          return false;
        }
      this.editable_master = true;
      item.editable = true;
      this.allerros = {}  
      this.group_rows.forEach((element) => {
        if(element._id != item._id){
          element.editable = false
        }
      });
    },
    submit (item) {
      this.items = item;
      this.submitForm();
    },
    async listOfferGroupOffer(group_id){
      try{
        let response = await Offer.listOfferGroupOffer(group_id)
        if(response.status == 200){
          let data = response.data.data
          data.forEach((element) => {
            element.editable = false
          });
          this.group_offers = data
        }
      }catch(error){
      }
    },
    async listActiveOffer(){
      try{
        let response = await Offer.listActiveOffer()
        if(response.status == 200){
          let data = response.data.data
          for(const key in data){
            this.offers.push({ value: data[key]._id, text:data[key].int_id+'-'+data[key].name })
          }
        }
      }catch(error){
      }
      console.log('offers',this.offers);
    },
    setRole(){
      const user = localStorage.getItem('user')
      if (user) {
        let role = JSON.parse(user)
        this.login_id=role._id
        this.isRights = role.rights
        this.isManager = role.role == 'manager'
        this.isAdvertiser = role.role == 'advertiser'
        this.isAdmin = role.role == 'admin'
        this.isPublisher = role.role == 'publisher'
      }
    },
    async submitForm(){
      try{
        let response = await Offer.storeGroupOffer(this.items)
        if(response.status == 201){
          const message = response.data.message;
          this.$toast.info(message, {
                    position: 'top-center'
                });
          this.listOfferGroup()
          this.items = this.default()
          this.$refs.myModalRef.hide();
          this.editable_master=false;
        }else{
          this.allerros = response.data.errors
        }
      }catch(error){
        this.$toast.info('Getting Error !', {
                    position: 'top-center',
                    class:'danger'
                })
      }
    },
    async update(item) {
      this.items._id = item._id;
      this.items.status = item.status;
      try{
        let response = await Offer.updateGroupOfferStatus(this.items)
        if(response.status == 200){
          this.$toast.info('Status Updated Successfully!', {
                    position: 'top-center'
                });
          this.listOfferGroup()
        }else{
          this.allerros = response.data.errors
        }
      }catch(error){

      }
    },
    async remove (item) {
      if(confirm('Are you sure to delete this Group?')){
        try{
          let response = await Offer.deleteGroupOffer(item._id)
          if(response.status == 200){
            this.listOfferGroup()
          }else{
            this.allerros = response.data.errors
          }
        }catch(error){
        }
      }
    },
    async listOfferGroup(){
      this.loadingData = true;
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        ...this.filters,
      };
      try{
        let response = await Offer.listGroupOffer(params)
        if(response.status == 200){
          let data = response.data.data.data
          //add editable and incremental id in each row
          data.forEach((element) => {
            element.editable = false
            element.status_text = this.group_status.find(x => x.value == element.status).text
          });
          this.group_rows = data
          this.totalRows = response.data.data.total
        }
      }catch(error){
      }
      this.loadingData=false;
    },
    async listStatus(){
      try{
        let response = await Common.listStatus()
        if(response.status == 200){
          let group_offer_status = response.data.offerGroup
          
          //pricing model
          for(const key in group_offer_status){
            this.group_status.push({ value: key, text: group_offer_status[key] })
          }
        }
      }catch(error){
      }
    },
    async loadData() {
      try {
        await this.listStatus()
        await this.listOfferGroup()
        await this.setRole()
      } catch (error) {
        console.error('Error loading data:', error);
      }
    }
  },
  data () {
    return {
      columns: [
        { label: 'Name', key: 'name', class: 'text-left', sortable: true },
        { label: 'Status', key: 'status', class: 'text-left', sortable: true },
        { label: 'Action', key: 'action', class: 'text-center' }
      ],
      filters: {
    name: '',
    status: null
  },
      group_rows: [],
      items: {
        _id:'',
        name: '',
        status: ''
      },
      allerros:{},
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10,20,50,100],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      group_status: [], 
      group_id: '',
      group_name:'',
      group_offers:[],
      offers:[],
      editable_master:false,
      loadingData:false,
      hosts: '',
      links:'',
      isAdmin:false,
      isManager:false,
      isAdvertiser:false,
      isPublisher:false,
      login_id: '',
    }
  },
  watch: {
    currentPage: 'listOfferGroup',
  },
  created(){
    this.loadData();
  },
  computed: {
    allFieldsValid() {
          return this.items.name && this.items.status;
      },
  }
}
</script>
